import React from 'react';
import { Search, Settings, Users, BarChart3 } from 'lucide-react';

export const HowItWorksSection = () => {
  const steps = [
    {
      num: '01',
      icon: Search,
      title: 'Conoce PastoreApp',
      description: 'Explora la plataforma y descubre cómo se adaptan los módulos a la realidad de tu iglesia.',
    },
    {
      num: '02',
      icon: Settings,
      title: 'Configura tu iglesia',
      description: 'Adapta la información a la estructura de tu comunidad: ministerios, grupos y procesos.',
    },
    {
      num: '03',
      icon: Users,
      title: 'Organiza tu comunidad',
      description: 'Carga miembros, asigna líderes, crea grupos y define las rutas de formación.',
    },
    {
      num: '04',
      icon: BarChart3,
      title: 'Empieza a gestionar',
      description: 'Centraliza la información y comienza a utilizar la plataforma con tu equipo.',
    },
  ];

  return (
    <section id="como-funciona" className="py-20 bg-white dark:bg-slate-900 border-t border-slate-200/60 dark:border-slate-800/60">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto space-y-4">
          <p className="text-xs font-black uppercase tracking-[0.2em] text-indigo-600 dark:text-indigo-400">
            Proceso Sencillo
          </p>
          <h2 className="text-3xl sm:text-4xl font-black text-slate-900 dark:text-white tracking-tight">
            Empieza en pocos pasos
          </h2>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, idx) => {
            const Icon = step.icon;
            return (
              <div key={idx} className="relative bg-slate-50 dark:bg-slate-950 p-8 rounded-[2.5rem] border border-slate-200/80 dark:border-slate-800/80 space-y-4 hover:shadow-lg hover:border-indigo-300 dark:hover:border-indigo-800 transition-all">
                <div className="flex items-center justify-between">
                  <span className="text-3xl font-black text-indigo-600/30 dark:text-indigo-400/30">{step.num}</span>
                  <div className="w-12 h-12 rounded-2xl bg-indigo-100 dark:bg-indigo-950/60 text-indigo-600 dark:text-indigo-400 flex items-center justify-center">
                    <Icon size={24} />
                  </div>
                </div>
                <h3 className="text-lg font-black text-slate-900 dark:text-white tracking-tight">{step.title}</h3>
                <p className="text-xs font-medium text-slate-600 dark:text-slate-400 leading-relaxed">{step.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
